import React from 'react'
import WebService from 'api/explus-api'
import Main from '../../Main'
import Ambasador from './Ambasador'

export default class AmbasadorContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      contact: {
        where_did_learn: '',
        why_ambassador: ''
      },
      loading: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.displaySelectedItem = this.displaySelectedItem.bind(this)
  }

  handleChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name

    this.setState({contact: {...this.state.contact, [name]: value}})
  }

  handleClick(value) {
    if (!value) {return}

    return e => {
      e.preventDefault()

      this.setState({
        contact: {...this.state.contact, where_did_learn: value}
      })
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({loading: true})
    WebService.ambassador(this.state.contact).then(() => {
      this.setState({loading: false})
    })
  }

  displaySelectedItem() {
    return this.state.where_did_learn
  }

  render() {
    return (
      <Main bannerImage={this.props.bannerImage}>
        <Ambasador loading={this.state.loading} submit={this.handleSubmit} change={this.handleChange} click={this.handleClick} where_did_learn={this.state.contact.where_did_learn || undefined} />
      </Main>
    )
  }
}
